import { render, staticRenderFns } from "./FileUploadTemplate.vue?vue&type=template&id=726fc31d&"
import script from "./FileUploadTemplate.vue?vue&type=script&lang=js&"
export * from "./FileUploadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadTemplate.vue?vue&type=style&index=0&id=726fc31d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports